import type { MeUser } from '~/server/types';

// Make the type the least restrictive as possible to accept all member types.
type UserProfessionalCategory = Pick<
    NonNullable<Pick<MeUser, 'ProfessionalCategory'>['ProfessionalCategory']>,
    'Title'
>;
type UserType = Pick<MeUser, 'UserType'> & {
    ProfessionalCategory?: UserProfessionalCategory | null;
};

/**
 * Get the user's occupation. If the user is a professional, this will return
 * the professional's industry (professional category). If the user is a staff
 * member, this will return "Staff".
 * @param user The user to get the occupation for.
 * @returns The user's occupation.
 */
export function getUserOccupation(user: UserType): string {
    if (user.UserType.toLowerCase() === 'staff') {
        return user.UserType;
    }
    return user.ProfessionalCategory?.Title ?? user.UserType;
}
